var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.7125 14.2377V21.7252C26.7125 25.1752 23.9125 27.9752 20.4625 27.9752H9.5375C6.0875 27.9752 3.2875 25.1752 3.2875 21.7252V14.3252C4.2375 15.3502 5.5875 15.9377 7.05 15.9377C8.625 15.9377 10.1375 15.1502 11.0875 13.8877C11.9375 15.1502 13.3875 15.9377 15 15.9377C16.6 15.9377 18.025 15.1877 18.8875 13.9377C19.85 15.1752 21.3375 15.9377 22.8875 15.9377C24.4 15.9377 25.775 15.3252 26.7125 14.2377Z",
    fill: "#DC1F5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7375 1.5625H11.2375L10.3125 10.7625C10.2375 11.6125 10.3625 12.4125 10.675 13.1375C11.4 14.8375 13.1 15.9375 15 15.9375C16.925 15.9375 18.5875 14.8625 19.3375 13.15C19.5625 12.6125 19.7 11.9875 19.7125 11.35V11.1125L18.7375 1.5625Z",
    fill: "#DC1F5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.95 10.3375L27.5875 6.875C27.0625 3.1 25.35 1.5625 21.6875 1.5625H16.8875L17.8125 10.9375C17.825 11.0625 17.8375 11.2 17.8375 11.4375C17.9125 12.0875 18.1125 12.6875 18.4125 13.225C19.3125 14.875 21.0625 15.9375 22.8875 15.9375C24.55 15.9375 26.05 15.2 26.9875 13.9C27.7375 12.9 28.075 11.6375 27.95 10.3375Z",
    fill: "#DC1F5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M8.2375 1.5625C4.5625 1.5625 2.8625 3.1 2.325 6.9125L1.9875 10.35C1.8625 11.6875 2.225 12.9875 3.0125 14C3.9625 15.2375 5.425 15.9375 7.05 15.9375C8.875 15.9375 10.625 14.875 11.5125 13.25C11.8375 12.6875 12.05 12.0375 12.1125 11.3625L13.0875 1.575H8.2375V1.5625Z",
    fill: "#DC1F5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 20.8248C12.6 20.9873 11.4 22.3373 11.4 23.9373V27.9748H18.5875V24.3748C18.6 21.7623 17.0625 20.5248 14.1875 20.8248Z",
    fill: "#DC1F5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.e740c6e625fbb8f0c44f4108295df60e.svg";
export { ForwardRef as ReactComponent };